import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  softwareSettings: {
    generalSettings: {}, 
    companySettings: {}, 
  },
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSoftwareSettings: (state, action) => {
      state.softwareSettings = action.payload;
    },
    clearSoftwareSettings: (state) => {
      state.softwareSettings = initialState.softwareSettings;
    },
  },
});

export const { setSoftwareSettings, clearSoftwareSettings } = settingsSlice.actions;

// Selectors
export const selectSoftwareSettings = (state) => state.settings.softwareSettings;
export const selectGeneralSettings = (state) => state.settings.softwareSettings.generalSettings;
export const selectCompanySettings = (state) => state.settings.softwareSettings.companySettings;

export default settingsSlice.reducer;